import { render, staticRenderFns } from "./HomeSlickVideoSlider.vue?vue&type=template&id=5601d38c&scoped=true"
import script from "./HomeSlickVideoSlider.vue?vue&type=script&lang=js"
export * from "./HomeSlickVideoSlider.vue?vue&type=script&lang=js"
import style0 from "./HomeSlickVideoSlider.vue?vue&type=style&index=0&id=5601d38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5601d38c",
  null
  
)

export default component.exports